import React, { useEffect, useState } from 'react'
import {ReactComponent as Chip} from '../../../assets/new-icons/chip.svg';
import {ReactComponent as Asterisk} from '../../../assets/new-icons/asterisk.svg';
import ArrowForwardIos from '@mui/icons-material/ArrowForwardIos';

function Step1(props) {
    const [disabled, setDisabled] = useState(true)
    useEffect(() => {
        if(props.name) {
            setDisabled(false)
        }
    },[])
    const addName = (e) => {
        props.setName(e)
        e.length > 3 ? setDisabled(false) : setDisabled(true)
    }
    const nextStep = () => {
        props.setStep(props.step + 1)
    }
 
    return (
        <div className='step1'>
            {props.idMethod === 1 ? (
                <>
                    <div className="cardContainer">
                        <div className="nameSvgContainer">
                            <p className="main p-16 mb-0">La tua carta</p>
                            <div className="cardCenter">
                                <Chip/>
                            </div>
                        </div>
                        <div className="cardBottom">
                            <p className='main p-16 mb-0'>
                                {props.name}
                            </p>
                        </div>
                    </div>  
                    <div className="inputContainer">
                        <p className="main p-16 mb-0">Titolare della carta:</p>
                        <input type="text" placeholder='Nome e Cognome' value={props.name} onChange={(e) => addName(e.target.value)} />
                    </div> 
                </>
            ) : (
                <>
                    <div className="inputContainer">
                        <p className="main p-16 mb-0">Titolare del conto bancario:</p>
                        <input type="text" placeholder='Nome e Cognome' value={props.name} onChange={(e) => addName(e.target.value)} />
                    </div> 
                </>
            )}
             <div className="buttonActivate">
                <button disabled={disabled} onClick={() => nextStep()}>
                    Avanti <ArrowForwardIos fontSize='18px' />
                </button>
            </div>
        </div>
    )
}

export default Step1
